export interface OtherExpense {
  id: string;
  expenseDate: string;
  expenseType: string;
  category: string;
  paidTo: string;
  amount: number;
  contactNumber?: string;
  location?: string;
  notes?: string;
  payments: PaymentDetail[];
  createdAt: string;
  updatedAt: string;
  totalPaid?: number;
  balance?: number;
}

export interface OtherExpenseFormData {
  expenseDate: string;
  category: string;
  paidTo: string;
  amount: number | string;
  contactNumber: string;
  location: string;
  notes: string;
  expenseType: string;
  payments: PaymentDetail[];
}

// For multiple expense entries
export interface OtherExpenseEntry {
  id?: string | null;
  expenseType: string;
  category: string;
  expenseDate: string;
  paidTo: string;
  amount: number | string;
  contactNumber: string;
  location: string;
  notes: string;
  // Payment details
  payments: PaymentDetail[];
  deletedPayments?: PaymentDetail[];
  isDeleted?: boolean;
  isEdited?: boolean;
  isNew?: boolean;
}

export interface PaymentDetail {
  id?: string;
  type: string;
  mode: string;
  amount: number | string;
  date: string;
  location: string;
  receivedFrom: string;
  remarks?: string;
  status: string;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string;
  isEdited?: boolean;
  isDeleted?: boolean;
  isNew?: boolean;
  otherExpenseId?: string;
}

export interface MultipleExpenseFormData {
  expenses: OtherExpenseEntry[];
}

export interface OtherExpenseListResponse {
  expenses: OtherExpense[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface OtherExpenseFilters {
  category: string;
  paidTo: string;
  startDate: string;
  endDate: string;
  sortBy: string;
  sortOrder: "ASC" | "DESC";
}

export const EXPENSE_CATEGORIES = [
  "Insurance",
  "Electricity Bill",
  "Water Bill",
  "Internet/Phone Bill",
  "Branch Office Rent",
  "Branch Supplies",
  "Legal & Professional",
  "Marketing & Advertising",
  "Travel Allowance",
  "Operational Cost",
  "Miscellaneous",
  "Other",
] as const;

export type ExpenseCategory = (typeof EXPENSE_CATEGORIES)[number];

// Helper function to get empty expense entry
export const getEmptyOtherExpenseEntry = (
  expenseType: string
): OtherExpenseEntry => ({
  expenseType: expenseType,
  category: expenseType === "Other" ? "" : expenseType,
  expenseDate: new Date().toISOString().split("T")[0],
  paidTo: "",
  amount: "",
  contactNumber: "",
  location: "",
  notes: "",
  payments: [],
  isDeleted: false,
  isEdited: false,
  isNew: true,
});

// Helper function to map expense entry to API request
export const mapOtherExpenseEntryToApiRequest = (
  expense: OtherExpenseEntry
) => ({
  expenseDate: expense.expenseDate,
  expenseType: expense.expenseType,
  category: expense.category,
  paidTo: expense.paidTo,
  amount: Number(expense.amount),
  contactNumber: expense.contactNumber,
  location: expense.location,
  notes: expense.notes,
  // payments: expense.payments,
});

export const PAYMENT_MODES = [
  "CASH",
  "BANK_TRANSFER",
  "UPI",
  "CHEQUE",
  "ONLINE",
  "OTHER",
] as const;

export const PAYMENT_TYPES = ["ADVANCE", "FINAL"] as const;
